import { isAction, isRejected, type Middleware } from '@reduxjs/toolkit';

import { reduxFatalitySlice } from '@/store/reduxFatality/slice.ts';

import { logger } from '../components/SgwtBootstrap/logger.ts';

export const reduxFatalityMiddleware: Middleware = (api) => (next) => (action) => {
  if (!isAction(action)) {
    // most unlikely
    console.warn('invalid action', { action });
    return undefined;
  }

  // This code will make the app crash when an async thunk fails but only if it's from an exception
  // FIXME: this is a really weird, undocumented behavior we are relying on
  //  - errors thrown inside async thunks will produce a rejected action with a 'stack' attribute
  //  - errors from http endpoint (http code 500, etc) in RTK query will also produce a rejected action but without the 'stack' attribute
  if (isRejected(action) && 'stack' in action.error) {
    const errorMessage = action.error.message ?? 'Unknown error';
    const errorStack = action.error.stack;
    logger.logError(
      'Error in redux thunk: {errorMessage_s} {errorStack_s} {action_s}',
      errorMessage,
      errorStack,
      JSON.stringify(action),
    );
    api.dispatch(
      reduxFatalitySlice.actions.setError({
        errorMessage,
        errorStack,
        action,
      }),
    );
    return undefined;
  }

  try {
    return next(action);
  } catch (error) {
    const errorMessage = error instanceof Error ? error.message : 'Unknown error';
    const errorStack = error instanceof Error ? error.stack : undefined;

    logger.logError(
      'Error in redux callback: {errorMessage_s} {errorStack_s} {action_s}',
      errorMessage,
      errorStack,
      JSON.stringify(action),
    );

    api.dispatch(
      reduxFatalitySlice.actions.setError({
        errorMessage,
        errorStack,
        action,
      }),
    );
    return undefined;
  }
};
